import * as _ from 'lodash';
import * as Types from '../types';
import * as ID from '../../../util/id';
import Observable from 'zen-observable';
import * as CG from './graph';
import {ResolverContext} from './resolverContext';

export interface Listener {
  id: string;
  done: boolean;
  // TODO: I'm maybe not using observers correctly.
  observer: ZenObservable.SubscriptionObserver<any>;
  // Which node are they listening to?
  node: CG.Node<any>;
}

async function executeForwardListeners(
  context: ResolverContext,
  forwardGraph: CG.ForwardGraph,
  listeners: Listener[]
) {
  const targetNodes = listeners.map(l => l.node);
  for (const node of targetNodes) {
    CG.updateForwardGraph(forwardGraph, node);
  }
  await CG.executeForward(context, forwardGraph);
  return await CG.getNodeResults(forwardGraph, targetNodes);
}

// Warning: This probably leaks memory in a bad way. We return
// all nodes in the forward graph that we've ever executed currently!
// TODO: clean up
export class Client {
  context: ResolverContext;
  forwardGraph: CG.ForwardGraph = CG.newForwardGraph();
  listeners: {[id: string]: Listener} = {};

  constructor(context: ResolverContext) {
    this.context = context;
    this.loopIteration();
  }

  loopIteration = async () => {
    const notDoneListeners = Object.values(this.listeners).filter(l => !l.done);
    Object.values(this.listeners).forEach(l => (l.done = true));
    if (notDoneListeners.length > 0) {
      console.log(
        'cg executing nodes',
        _.countBy(
          notDoneListeners.map(l =>
            l.node.nodeType === 'output'
              ? l.node.fromOp.name
              : 'nodeType:' + l.node.nodeType
          )
        )
      );
      // console.time('graph execute');
      const results = await executeForwardListeners(
        this.context,
        this.forwardGraph,
        notDoneListeners
      );
      // console.timeEnd('graph execute');
      // console.time('graph notify');
      // notify listeners
      for (let i = 0; i < notDoneListeners.length; i++) {
        const listener = notDoneListeners[i];
        // Make sure the listener hasn't unsubscribed
        if (this.listeners[listener.id] != null) {
          const observer = listener.observer;
          observer.next(results[i]);
        } else {
          console.log('MISSING LISTENER', listener.id);
        }
      }
      // console.timeEnd('graph notify');
    }
    setTimeout(this.loopIteration, 50);
  };

  subscribe<T extends Types.Type>(node: CG.Node<T>) {
    return new Observable(observer => {
      const listenerId = ID.ID();
      this.listeners[listenerId] = {
        id: listenerId,
        done: false,
        observer,
        node,
      };
      return () => {
        delete this.listeners[listenerId];
      };
    });
  }
}
